import { render, staticRenderFns } from "./OtherLoyaltyDiscount.vue?vue&type=template&id=e5806e28&"
import script from "./OtherLoyaltyDiscount.vue?vue&type=script&lang=js&"
export * from "./OtherLoyaltyDiscount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports